import type { UpdateQueryParameterAction } from '@lighthouse/core'
import type { ActionFlowNode, FlowNodeResultADT } from '@lighthouse/shared'
import { asyncGenerateVariableValue, getInitInnerTypeADTValue, isEmptyRichTextValue } from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { find } from 'rambda'

import type { ExecuteActionParams } from '../type'

export const updateQueryParameter = async (
    config: UpdateQueryParameterAction['data']['updateQueryParameter'] | undefined,
    params: ExecuteActionParams
) => {
    const { actionEvents, pageQueryParameterValues } = params
    if (!config) {
        return
    }
    const { queryParameterId, value } = config
    const queryParameterSchema = find(item => item.id === queryParameterId, pageQueryParameterValues || [])
    if (!queryParameterId || !queryParameterSchema) {
        return
    }
    const val =
        value && !isEmptyRichTextValue(value)
            ? await asyncGenerateVariableValue({ innerType: queryParameterSchema.innerType, jsonContent: value, extraParams: params })
            : getInitInnerTypeADTValue(queryParameterSchema.innerType).value
    actionEvents.updateQueryParameter({
        queryParamId: queryParameterId,
        value: safeToString(val)
    })

    return true
}

export const handleUpdateQueryParameterList = async (
    config: UpdateQueryParameterAction['data']['updateQueryParameter'] | undefined,
    params: ExecuteActionParams
): Promise<FlowNodeResultADT> => {
    await updateQueryParameter(config, params)
    return {
        type: 'record',
        success: true
    }
}

export const handleUpdateQueryParameterStream = async (
    node: ActionFlowNode<{ config: UpdateQueryParameterAction['data']['updateQueryParameter'] }>,
    params: ExecuteActionParams
): Promise<FlowNodeResultADT> => {
    await updateQueryParameter(node.data.config, params)
    return {
        type: 'record',
        success: true
    }
}
